import { FC, ReactElement } from 'react';

import { useDialog } from 'hooks/useDialog';

import DokumentationsresursPresentationModal from 'components/dokumentationsresursPresentationModal/DokumentationsresursPresentationModal';
import SkeletonImage from 'components/skeleton/SkeletonImage';
import SkeletonItem from 'components/skeleton/SkeletonItem';

import { DokumentCommonResursData } from 'models';

import { useLazyGetArkivresursQuery } from 'api/endpoints/arkivresursSlice';
import { formatDate } from 'utilities/dateUtilities';

export const ArkivResurs: FC<{ resursdata: DokumentCommonResursData; shouldLoad?: boolean }> = ({
  resursdata,
  shouldLoad = false
}): ReactElement => {
  const { setDialog, unsetDialog } = useDialog();
  const [getArkivresurs] = useLazyGetArkivresursQuery();

  return (
    <>
      <button
        className="tw-block tw-h-32 tw-w-full tw-overflow-hidden"
        onClick={async () => {
          if (resursdata && resursdata.uri) {
            const { data: resurs, isSuccess } = await getArkivresurs(resursdata.uri);

            if (isSuccess) {
              setDialog(DokumentationsresursPresentationModal, { resurs, onClose: () => unsetDialog() });
            }
          }
        }}
      >
        {((!resursdata || resursdata.thumbnailUrl) && (
          <SkeletonImage
            className="tw-h-32 tw-w-full tw-object-cover"
            skeletonClassNames="tw-h-32 tw-w-full"
            src={resursdata?.thumbnailUrl}
            animated={shouldLoad}
            alt="Arkivbild"
          />
        )) || (
          <div className="tw-flex tw-h-32 tw-w-full tw-items-center tw-justify-center tw-rounded-md tw-bg-raa-gray-3">
            <div className="tw-text-center tw-text-raa-gray-6">
              <span className="raa-icon raa-icon-image tw-block"></span>
              Ingen bild
            </div>
          </div>
        )}
        {resursdata?.titel === undefined && (
          <SkeletonItem classNames="tw-h-6 tw-w-20 tw-mt-2" rounded="md" animated={shouldLoad} />
        )}
      </button>
      {resursdata?.titel && <p className="tw-mt-1 tw-break-words tw-text-size-0.813">{resursdata?.titel}</p>}
      {resursdata?.titel && <p className="tw-text-size-0.813">{formatDate(resursdata?.tillkomstdatum)}</p>}
    </>
  );
};
